import React from 'react';
import { getTypeFromChannels } from '../utilsDesign';

const colors = {
  G: '#ffc49c',
  MG: '#ff9650',
  M: '#ff7a7f',
  P: '#ffa4f9',
  R: '#b4fff0'
};

function Def1SVG({ color }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill={color} />
    </svg>
  );
}

function Def2SVG({ colors }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 19.9492C3.94674 19.4474 0 15.1853 0 10C0 4.81467 3.9467 0.551549 9 0.0498047V19.9492Z" fill={colors[0]} />
      <path d="M11 19.9492C16.0533 19.4474 20 15.1853 20 10C20 4.81467 16.0533 0.551549 11 0.0498047V19.9492Z" fill={colors[1]} />
    </svg>
  );
}

function Def3SVG({ colors }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 9L1.83301 15.7676C0.679763 14.1375 0 12.1487 0 10C0 4.81467 3.9467 0.551549 9 0.0498047V9Z" fill={colors[0]} />
      <path d="M11 0.0498047C16.0533 0.551549 20 4.81467 20 10C20 12.1489 19.3195 14.1375 18.166 15.7676L11 9V0.0498047Z" fill={colors[1]} />
      <path d="M16.8945 17.2383C15.1003 18.9478 12.674 20 10 20C7.32578 20 4.8988 18.9481 3.10449 17.2383L10 11L16.8945 17.2383Z" fill={colors[2]} />
    </svg>
  );
}

function Def4SVG({ colors }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 9H0.0498047C0.51889 4.27562 4.27562 0.51889 9 0.0498047V9Z" fill={colors[0]} />
      <path d="M9 19.9492C4.27566 19.4801 0.518887 15.7244 0.0498047 11H9V19.9492Z" fill={colors[1]} />
      <path d="M11 0.0498047C15.7244 0.51889 19.4811 4.27562 19.9502 9H11V0.0498047Z" fill={colors[2]} />
      <path d="M19.9502 11C19.4811 15.7244 15.7243 19.4801 11 19.9492V11H19.9502Z" fill={colors[3]} />
    </svg>
  );
}

export function DefinitionIcon({ design = {} }) {
  if (!design || !design.split || !Array.isArray(design.split)) return null;

  const groupTypes = design.split.map(group => getTypeFromChannels(group));
  // console.log('groupTypes = ', groupTypes);
  const groupColors = groupTypes.map(type => colors[type] || 'black');

  switch (design.split && design.split.length) {
    case 1:
      return <Def1SVG color={groupColors[0]} />;
    case 2:
      return <Def2SVG colors={groupColors} />;
    case 3:
      return <Def3SVG colors={groupColors} />;
    case 4:
      return <Def4SVG colors={groupColors} />;
    default:
      return null;
  }
}